import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import App from './App';
import styles from './assets/styles/main.css';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Helmet>
        <meta charSet="utf-8" />
        <meta name="author" content="Brittany Landorf" />
        <meta name="description" content="TODO" />
        <title>Visiting the Female Saints of Fez, Rawḍ al-Awliyā’</title>
    </Helmet>

    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
